module.exports = __webpack_public_path__ + "img/special-you-icon1.c64a932f.png";